import EmptyResults from '@/assets/images/empty-results.png'

export function NoResults() {
  return (
    <div className="flex w-full flex-col-reverse px-4 pt-8 md:flex-row md:items-center md:justify-center md:py-12">
      <div className="mt-6 flex flex-col md:mr-32 md:mt-0 ">
        <h1 className="text-header-lg ">That&rsquo;s everything!</h1>
        <p className="mt-4 font-medium md:mt-2">No results found.</p>
      </div>

      <img alt="uh oh" className="w-20" src={EmptyResults} />
    </div>
  )
}
